import { render } from "./fifthstepGroomingView.vue?vue&type=template&id=aeedad56&scoped=true"
import script from "./fifthstepGroomingView.vue?vue&type=script&lang=js"
export * from "./fifthstepGroomingView.vue?vue&type=script&lang=js"

import "./fifthstepGroomingView.vue?vue&type=style&index=0&id=aeedad56&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeedad56"]])

export default __exports__